import { MasterService } from '../services/master.service';
import config from "../config";
const {
  apiGateway: { ASSISTANT_OP, APP_API },
} = config;
export const saveAssistant = async (data, params) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}saveassistant`, data);
  } catch (error) {
    throw error;
  }
};

export const updateAssistant = async (data, id) => {
  try {
    data.assistantId = id;
    return MasterService.post(`${ASSISTANT_OP}assistants/uuid`, data);
  } catch (error) {
    throw error;
  }
};

export const listAssistant = async () => {
  try {
    return MasterService.post(`${ASSISTANT_OP}assistants`);
  } catch (error) {
    throw error;
  }
}

export const getAssistantInfo = async (uuid) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}assistant/id`, { uuid });
  } catch (error) {
    throw error;
  }
}

export const accessableAssistants = async (data = {}) => {
  try {
    // Construct the query string based on the params object (if it contains searchOption)
    // const query = new URLSearchParams(params).toString();
    
    // If there is a query string, append it to the API endpoint
    // const url = query 
    //   ? `${ASSISTANT_OP}accessassistants?${query}` 
    //   : `${ASSISTANT_OP}accessassistants`;
    
    return MasterService.post(`${ASSISTANT_OP}accessassistants`, data);
  } catch (error) {
    throw error;
  }
};


export const Assistantlist = async (data) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}filterassistants`, data);
  } catch (error) {
    throw error;
  }
};

export const getAssistantRating = (assistantId) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}rating/assistant`, { assistantId });
  } catch (error) {
    throw error;
  }
}

export const postAssistantRating = (data) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}rating`, data);
  } catch (error) {
    throw error;
  }
}

export const categories = (payload) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}categories/list`, { payload });
  } catch (error) {
    throw error;
  }
};
export const createCategories = (data) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}categories`,data);
  } catch (error) {
    throw error;
  }
}
export const changeStatusCategories = (data,id) => {
  try {
    data.id = id;
    return MasterService.post(`${ASSISTANT_OP}categories/update`,data);
  } catch (error) {
    throw error;
  }
}

export const assistantAssignedUsers = (data) => {
  try {
    return MasterService.post(`${APP_API}history/getUsageData`, data);
  } catch (error) {
    throw error;
  }
}

export const suggestImageUrl = (data) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}generateIcon`, data);
  } catch (error) {
    throw error;
  }
}

export const getWorkFlowUrl = () => {
  try {
    return MasterService.post(`${APP_API}predection/chatflowToken`)
    } catch (error) {
      throw error;
    }
}

export const deactivateAssistant = async (data) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}deactivateassistant`, data);
  } catch (error) {
    throw error;
  }
};

export const duplicateAssistant = async (data) => {
  try {
    return MasterService.post(`${ASSISTANT_OP}assistant/duplicate`, data);
  } catch (error) {
    throw error;
  }
};

export const getAllOrgAssistants = async (data) => {
  try {
    const res = MasterService.post(`${APP_API}/genai/org/assistants`, data);
    return res;
  } catch (error) {
    console.log("🚀 ~ getAllOrgAssistants ~ error:", error)
    throw error;
  }
};

export const generateProxyToken = async (data) => {
  try {
    return MasterService.post(`${APP_API}auth/generateproxytoken`, data);
  } catch (error) {
    throw error;
  }
};

export const headlessAssistantUpdate = async (data) => {
  try {
    const res = MasterService.post(`${APP_API}/genai/headlessassistant`, data);
    return res;
  } catch (error) {
    console.log("🚀 ~ getAllOrgAssistants ~ error:", error)
    throw error;
  }
};

export const getPluginMasterData = async (payload) => {
  try {
    const res = MasterService.post(`${APP_API}/genai/getPluginMasterData`, payload);
    return res;
  } catch (error) {
    console.log("🚀 ~ getAllOrgAssistants ~ error:", error)
    throw error;
  }
};

export const updatePluginMasterData = async (payload) => {
  try {
    const res = MasterService.post(`${APP_API}/genai/updatePluginMasterData`, payload);
    return res;
  } catch (error) {
    console.log("🚀 ~ getAllOrgAssistants ~ error:", error)
    throw error;
  }
};